import { useEffect, useState } from "react";

import { migrateLocalStorageToIdb } from "./migrateLocalStorageToIdb";

export function LocalStorageToIdb({ children }: { children: React.ReactNode }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    migrateLocalStorageToIdb()
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <p>"Migrating data..."</p>;
  }

  if (error) {
    throw new Error(`Failed to migrate data: ${error.message}`);
  }

  return <>{children}</>;
}
